import React from "react";
import { HomeRounded, WorkRounded, AssignmentTurnedInRounded } from "@mui/icons-material";

export const HeaderPages = () => {
  const pages = [
    {
      title: "Home",
      icon: <HomeRounded titleAccess="Home" />,
      selected: false,
    },
    {
      title: "Portfolio",
      icon: <WorkRounded titleAccess="Portfolio" />,
      selected: false,
    },
    {
      title: "Skills",
      icon: <AssignmentTurnedInRounded titleAccess="Skills" />,
      selected: false,
    },
    /* {
        title: "Contact",
        icon: <ContactPageRounded titleAccess="Contact" />,
        selected: false,
      }, */
  ];

  return pages;
};
